module.exports = __webpack_public_path__ + "aa1a1b588baca4b9e898a9081236456f.svg";